module.exports = __webpack_public_path__ + "static/media/marker-current-heading.eddb6b6b.png";